import { Media } from '../media/Media'
import { Artist } from '../artist/Artist'
import { ArtworkReaction } from './ArtworkReaction'
import { Gallery } from '@/services/galleries/Gallery'

interface Category {
  id?: string;
  name?: string;
}

export class Artwork {
  id?: string = undefined
  title?: string = undefined
  slug?: string = undefined
  description?: string = ''
  price?: string
  category?: Category = {}
  technique?: Category = {}
  createdYear?: number = undefined
  width?: number
  height?: number
  dimension?: string | null = undefined
  orientation?: 'portrait' | 'landscape' = undefined
  isFramed?: boolean = undefined
  isForSale?: boolean = undefined
  isHangReady?: boolean = undefined
  isOrderable?: boolean = undefined
  isTestable?: boolean = undefined
  isPublished?: boolean = undefined
  is_in_gallery: boolean = false
  is_suspended: boolean = false
  sizeRange?: 'Small' | 'Medium' | 'Large' | 'XL' | 'XXL' = undefined
  media?: Media[] | Media = undefined
  mediaCount: number = 0
  artist?: Artist = undefined
  views?: number
  favorites?: number
  favoriteId?: string
  path?: string
  vatAmount?: string
  vatRate?: string
  orderColumn?: number
  publishedAt?: string | null = undefined
  likes_count: number = 0
  hearts_count: number = 0
  surprises_count: number = 0
  virtual_exhibition: Gallery | null = null
  userReaction: ArtworkReaction | null = null
  video_id: string | null = null
  my_subscription_id: string | null = null

  constructor (data: Partial<Artwork> = {}) {
    Object.assign(this, data)
  }

  addReaction (reaction: ArtworkReaction): void {
    this.recountReactions(reaction)
    this.userReaction = reaction
  }

  private recountReactions (reaction: ArtworkReaction) {
    if (reaction === ArtworkReaction.Like) {
      this.likes_count++
      return
    }
    if (reaction === ArtworkReaction.Heart) {
      this.hearts_count++
      return
    }
    if (reaction === ArtworkReaction.Surprise) {
      this.surprises_count++
      return
    }
  }

  get price_value () {
    return parseFloat((this.price || '0').replace(',', '.'))
  }
}
